/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LicenceModels } from '../../models/licence-models';
import { LicenseRespose } from '../../models/license-respose';

export interface AuthRegister$Params {
      body: LicenceModels
}

export function authRegister(http: HttpClient, rootUrl: string, params: AuthRegister$Params, context?: HttpContext): Observable<StrictHttpResponse<LicenseRespose>> {
  const rb = new RequestBuilder(rootUrl, authRegister.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LicenseRespose>;
    })
  );
}

authRegister.PATH = '/api/Auth/register';
